export default "__VITE_ASSET__Dco8HEGM__"